import {
  isSecurityPublicationEnabled,
  resolveSecurityLaunchEnvironment,
} from './security-launch-control';

/**
 * Vite-only adapter. The pure launch-control module remains usable by the
 * worker and tests, while this build-time value keeps production prerendered
 * pages and links out of the production bundle entirely.
 */
const viteEnvironment = (import.meta.env as { VITE_ENVIRONMENT?: string } | undefined)
  ?.VITE_ENVIRONMENT;
const prerenderEnvironment = typeof process === 'undefined' ? undefined : process.env.VITE_ENVIRONMENT;

export const SECURITY_PUBLICATION_ENABLED = isSecurityPublicationEnabled(
  resolveSecurityLaunchEnvironment(viteEnvironment ?? prerenderEnvironment)
);
